module.exports = __webpack_public_path__ + "luckycatresort-build/img/logo-default.67cc6a72.svg";